module.exports = __webpack_public_path__ + "static/media/font-adjustment-increase.1de7051c.svg";